const P = ({ children, additionalClass }) => (
  <p className={`custom-text-grey-400  poppins-medium mt-2 mb-4 ${additionalClass}`}>{children}</p>
);

export default P;
